module.exports = __webpack_public_path__ + "media/images/logo-4bb90a42d4b561b25e25b20a1c4c9094.svg";